import { useStation } from '@app/core/stations/hooks/useStation';
import { SocialPlatform, SocialPlatformEnum } from '@app/modules/social-export/domain/platforms';
import { Station } from '@mi-front/core';

export function useSocialExportEnabledForStation(stationId: string, platform: SocialPlatform) {
  const station = useStation(stationId);

  return isSocialExportEnabledForStation(station, platform);
}

export function isSocialExportEnabledForStation(
  station: Station,
  platform: SocialPlatform,
): boolean {
  if (platform.id === SocialPlatformEnum.DEMO) {
    return true;
  }

  return (
    station.featuresConfig?.fragments?.platformUpload?.[platform.id.toLowerCase()]?.enabled === true
  );
}
